module.exports = __webpack_public_path__ + "media/img/sbt-test/Scholarships2u-SBT-Bundle-6cd6afa5cc3f29c3bfae3d08619df3e2.svg";